document.addEventListener('DOMContentLoaded', function () {
  const langList = document.querySelector('.lang__list');
  if (!langList) return;

  const langBlock = document.querySelector('.lang');
  langBlock.addEventListener('click', () => toggleDropdown());

  function toggleDropdown() {
    langBlock.classList.toggle('lang_open');
  }
});